export default __webpack_public_path__ + "static/media/background.1d231ea3.jpg";